import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=6120c65c"
var script = {}
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=6120c65c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports